module.exports = __webpack_public_path__ + "static/media/san-francisco.5f14ad28.webp";